export const isLocal = () => typeof window !== 'undefined' && window.location?.host.includes('localhost');
// This
export const shouldLoginPassOnLocal = () => {
    if (!isLocal)
        return false;
    const query = new URLSearchParams(window.location.search);
    return typeof query.get('login') === 'string';
};
export const mockedLocalLoginResponse = () => {
    const mockedResponse = {
        success: true,
        error: false,
        hasCompleteCV: true,
        statusCode: 200,
    };
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(mockedResponse);
        }, 2000);
    });
};
//# sourceMappingURL=local.js.map